export const isDefined = <T>(variable?: T): variable is T extends undefined ? never : T =>
    typeof variable !== 'undefined';
